import { GET_ERRORS } from "../actions";
const initialState = {};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return action.payload;

    default:
      return state;
  }
}
